import React, { useState } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/home-care-banner.png';
import Card1 from '../components/img/home-care-card-1.png';
import Card2 from '../components/img/home-care-card-2.png';
import Card3 from '../components/img/home-care-card-3.png';
import Card4 from '../components/img/home-care-card-4.png';
import Card5 from '../components/img/home-care-card-5.png';
import Calendar from '../components/img/calendar.png';
import Stethoscope from '../components/img/stethoscope.png';
import Hopital from '../components/img/hospital.png';
import Rupees from '../components/img/rupees.png';
import List from '../components/img/list.png';
import Siren from '../components/img/siren.png';
import FormImg from '../components/img/homecare-form-img.png'
import '../styles/pages.css';


function HomeCare() {
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        selected_package: '',
        consent: false
    });

    const [errors, setErrors] = useState({});

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false); // New state variable to track form submission

    const validateInput = (name, value) => {
        let error = '';
        switch (name) {
            case 'firstname':
            case 'lastname':
                if (!value.match(/^[A-Za-z]+$/)) {
                    error = 'This field should only contains alphabets.';
                }
                break;
            case 'email':
                if (!value.match(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/)) {
                    error = 'Please enter a valid email address.';
                }
                break;
            case 'phone':
                if (!value.match(/^\d{10}$/)) {
                    error = 'Please enter a valid mobile number.';
                }
                break;
            default:
                break;
        }
        return error;
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const error = validateInput(name, value);
        setErrors({
            ...errors,
            [name]: error
        });
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    
        const validationErrors = {};
        let isValid = true;
    
        Object.keys(formData).forEach((key) => {
            const error = validateInput(key, formData[key]);
            if (error) {
                isValid = false;
                validationErrors[key] = error;
            }
        });
    
        setErrors(validationErrors);
    
        if (!isValid) {
            return;
        }
    
        fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/homecare_form.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
                setSuccessMessage(data.message);
                setErrorMessage(''); // Clear any previous error message
                setIsSubmitted(true); // Set the form as submitted
                setFormData({ // Reset form fields
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    selected_package: '',
                    consent: false
                });
                setErrors({}); // Clear any previous validation errors
            } else {
                setErrorMessage(data.message);
                setSuccessMessage(''); // Clear any previous success message
            }
        })
        .catch((error) => {
            setErrorMessage('An error occurred. Please try again later.');
            setSuccessMessage(''); // Clear any previous success message
        });
    };
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Caritas Home Care</p>

                    <div class="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                        <p className="page-subtitle">
                            Compassionate and Skilled Care at Home, Tailored to Your
                            <br/>
                            Medical Needs. 
                        </p>
                    </div>

                    <div class="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                        <p className="page-subtitle">
                            Compassionate and Skilled Care at Home, Tailored to Your Medical Needs. 
                        </p>
                    </div>
                    <div className="page-box">
                        <div className="box-content">
                            <p>
                                Caritas Matha Hospital's Home Care Services extend compassionate and 
                                personalized medical care directly to patients in the comfort of their 
                                own homes. Our skilled healthcare professionals offer a comprehensive 
                                range of services, including medical treatments, nursing care, therapy 
                                sessions, and daily living assistance.
                            </p>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Clinical Nutrition" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='page-content'>
                    <p className='page-content-heading'>
                        Home Care at Its Finest: Experience Convenience and Quality
                        <br />
                        with Caritas Home Care
                        
                    </p>
                    <br />
                    <div className='homecare-page-details'>
                        <div className="home-care-card">
                            <div className="home-care-card-image">
                                <img src={Card1} alt="Card Image" />
                            </div>
                            <div className="home-care-card-content">
                                <p>
                                    Welcome to Caritas Home Care, your trusted partner in quality healthcare 
                                    delivered right to your doorstep. We offer a range of services, including 
                                    doctor visits, nursing care, lab services, physiotherapy, and ambulance 
                                    support, all tailored to meet your specific needs. Our mission is to ensure 
                                    your well-being with personalized care, allowing you to stay healthy and 
                                    comfortable at home. With our carefully designed packages, you can choose 
                                    the care that best fits your lifestyle. Your health is our priority, and 
                                    we're here to serve you with compassion and expertise.
                                </p>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <p>&nbsp;</p>

                    <div>
                        <p className='page-content-heading'>
                            Expert Home Care Services
                            <br />
                            Brought to Your Doorstep                            
                        </p>
                    </div>
                    <br/>

                     {/* New Card Section */}
                    <div className="homecare-card-container">
                        <div className="homecare-card-row">
                            <div className="homecare-card">
                                <div className="homecare-card-image">
                                    <img src={Card2} alt="Service 1" />
                                </div>
                                <div className="homecare-card-content">
                                    <h5>Doctor Consultation</h5>
                                    <p>Our team of experienced doctors is just a call away. Get professional medical advice and consultations without leaving your home.</p>
                                </div>
                            </div>
                            <div className="homecare-card">
                                <div className="homecare-card-image">
                                    <img src={Card3} alt="Service 2" />
                                </div>
                                <div className="homecare-card-content">
                                    <h5>Nursing Care</h5>
                                    <p>Receive dedicated nursing care for your specific medical needs, ensuring you or your loved ones have the best care possible.</p>
                                </div>
                            </div>
                        </div>
                        <div className="homecare-card-row">
                            <div className="homecare-card">
                                <div className="homecare-card-image">
                                    <img src={Card4} alt="Service 3" />
                                </div>
                                <div className="homecare-card-content">
                                    <h5>Laboratory Services</h5>
                                    <p>Access essential diagnostic tests from the comfort of your home, ensuring timely health check-ups.</p>
                                </div>
                            </div>
                            <div className="homecare-card">
                                <div className="homecare-card-image">
                                    <img src={Card5} alt="Service 4" />
                                </div>
                                <div className="homecare-card-content">
                                    <h5>Ambulance Service</h5>
                                    <p>In case of emergencies, our ambulance service is available to transport you safely to a medical facility.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End of New Card Section */}

                    <br/>

                    <div>
                        <p className='page-content-heading'>
                            Start Your Journey to Better Health Today.
                            <br />
                            Explore Our Health Checkup Packages.                        
                        </p>
                    </div>
                    <br/>
                    <p>&nbsp;</p>

                    <div className="package-container">
                            <div className="row package-row">
                                <div className="package-title col-lg-4">
                                    <h6>Basic Package</h6>
                                    <p>4,500/Year</p>
                                </div>
                                <div className="col-lg-8">
                                    <ul>
                                        <li>Doctor & Nurse Visit every 3 months</li>
                                        <li>BP, SPO2, Blood Sugar Test every 3 months</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="row package-row">
                                <div className="package-title col-lg-4">
                                    <h6>Basic Investigation Package</h6>
                                    <p>7,500/Year</p>
                                </div>
                                <div className="col-lg-8">
                                    <ul>
                                        <li>Doctor & Nurse Visit every 3 months</li>
                                        <li>BP, SPO2, Blood Sugar Test every 3 months</li>
                                        <li>RBS, RFT, HbA1c, Electrolyte, Urine Routine investigations every 3 months</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="row package-row">
                                <div className="package-title col-lg-4">
                                    <h6>Executive Package</h6>
                                    <p>9,750/Year</p>
                                </div>
                                <div className="col-lg-8">
                                    <ul>
                                        <li>Doctor & Nurse Visit Once in a month</li>
                                        <li>BP, SPO2, Blood Sugar Test Once in a month</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="row">
                                <div className="package-title col-lg-4">
                                    <h6>Executive Investigation Package</h6>
                                    <p>12,500/Year</p>
                                </div>
                                <div className="col-lg-8">
                                    <ul>
                                        <li>Doctor & Nurse Visit Once in a month</li>
                                        <li>BP, SPO2, Blood Sugar Test Once in a month</li>
                                        <li>RBS, RFT, HbA1c, Electrolyte, Urine Routine investigations Once in 3 months</li>
                                    </ul>
                                </div>
                            </div>
                            <p>&nbsp;</p>
                            <p><span>Note:</span> Please note that our home care services are available to residents within a 30-kilometer radius of Caritas Hospital.</p>
                    </div>

                    <p>&nbsp;</p>
                    <div>
                        <p className='page-content-heading'>
                            Where Care and Convenience Come Together.
                            <br />
                            Discover the Advantages of Home Care.
                        </p>
                    </div>
                    <br/>
                    
                    <div className="homecare-card-container">
                        <div className="homecare-card-row">
                            <div className="homecare-card">
                                <div className="homecare-card-content">
                                    <img className='homecare-card-2-img' src={Calendar} alt="Service 1" />
                                    <h5>Convenience</h5>
                                    <p>Receive medical care and services without the need for travel, saving you time and effort.</p>
                                </div>
                            </div>
                            <div className="homecare-card advantages-card">
                                <div className="homecare-card-content">
                                    <img className='homecare-card-2-img' src={Stethoscope} alt="Service 1" />
                                    <h5>Professional Assistance</h5>
                                    <p>Connect with experienced doctors, nurses, and specialists who put your well-being first.</p>
                                </div>
                            </div>
                            <div className="homecare-card advantages-card">
                                <div className="homecare-card-content">
                                    <img className='homecare-card-2-img' src={Hopital} alt="Service 1" />
                                    <h5>Personalized Care</h5>
                                    <p>Tailored healthcare services to meet your specific medical requirements, ensuring comprehensive care.</p>
                                </div>
                            </div>
                        </div>
                        <div className="homecare-card-row">
                        <div className="homecare-card">
                                <div className="homecare-card-content">
                                    <img className='homecare-card-2-img' src={Rupees} alt="Service 1" />
                                    <h5>Affordability</h5>
                                    <p>Cost-effective packages for all your healthcare needs, ensuring quality care without financial strain.</p>
                                </div>
                            </div>
                            <div className="homecare-card advantages-card">
                                <div className="homecare-card-content">
                                    <img className='homecare-card-2-img' src={List} alt="Service 1" />
                                    <h5>Regular Check-ups</h5>
                                    <p>Stay updated on your health with scheduled doctor visits and diagnostic tests.</p>
                                </div>
                            </div>
                            <div className="homecare-card advantages-card">
                                <div className="homecare-card-content">
                                    <img className='homecare-card-2-img' src={Siren} alt="Service 1" />
                                    <h5>Emergency Support</h5>
                                    <p>Quick access to ambulance services for timely emergency support when every second counts.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End of New Card Section */}

                    <p>&nbsp;</p>

                    <div>
                        <p className='page-content-heading'>
                            Reach Out for
                            <br />
                            Caritas Home Care Services                         
                        </p>
                    </div>

                    <p>&nbsp;</p>

                    <div className='homecare-form-section'>
                        <div className='homecare-form-img'>
                            <img src={FormImg} alt="Form Banner" />
                        </div>
                        <div className='homecare-form'>
                            <p><span>Note:</span> Please note that our home care services are available to residents within a 30-kilometer radius of Caritas Hospital.</p>
                            {!isSubmitted ? (
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group homecare-form-fields">
                                        <label style={{ color: 'red' }}>*</label>
                                        <input
                                            type="text"
                                            name="firstname"
                                            value={formData.firstname}
                                            onChange={handleChange}
                                            placeholder="First Name"
                                            required
                                            className="form-control"
                                        />
                                        {errors.firstname && <div style={{ color: 'red' }}>{errors.firstname}</div>}
                                    </div>
                                    <div className="form-group homecare-form-fields">
                                        <label style={{ color: 'red' }}>*</label>
                                        <input
                                            type="text"
                                            name="lastname"
                                            value={formData.lastname}
                                            onChange={handleChange}
                                            placeholder="Last Name"
                                            required
                                            className="form-control"
                                        />
                                        {errors.lastname && <div style={{ color: 'red' }}>{errors.lastname}</div>}
                                    </div>
                                        
                                    <div className="form-group homecare-form-fields">
                                        <label style={{ color: 'red' }}>*</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="Email"
                                            required
                                            className="form-control"
                                        />
                                        {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}
                                    </div>
                                    <div className="form-group homecare-form-fields">
                                        <label style={{ color: 'red' }}>*</label>
                                        <input 
                                            type="text" 
                                            name="phone"
                                            className="form-control"
                                            value={formData.phone} 
                                            onChange={handleChange} 
                                            placeholder='Phone Number' 
                                            required 
                                            pattern="\d{10}"
                                            maxLength="10"
                                            onInput={(e) => 
                                                e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                        />
                                        {errors.phone && <div style={{ color: 'red' }}>{errors.phone}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label style={{ color: 'red' }}>*</label>
                                        <select name="selected_package" value={formData.selected_package} onChange={handleChange} className='form-control' required>
                                            <option value="">Select Home Care Packages</option>
                                            <option value="Basic_Package">Basic Package</option>
                                            <option value="Basic_Investigation_Package">Basic Investigation Package</option>
                                            <option value="Executive_Package">Executive Package</option>
                                            <option value="Executive_Investigation_Package">Executive Investigation Package</option>
                                        </select>
                                    </div>
                                    <div className="form-group form-check form-checkbox">
                                        <input
                                            type="checkbox"
                                            name="consent"
                                            checked={formData.consent}
                                            onChange={handleChange}
                                            required
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label">
                                            By ticking, I agree to the Terms and Conditions, and I am giving my consent to receive updates through email and SMS. 
                                        </label>
                                    </div>
                                    {errorMessage && <div className="error-message" style={{ color: 'red' }}>{errorMessage}</div>}
                                    <button type="submit" className="form-button">Submit Now</button>
                                </form>
                            ) : (
                                <div className="success-message">
                                    <h1>Thank You!</h1>
                                    <p>Your message has been successfully submitted.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="more-services homecare-more-services">
                    <p className="more-services-heading">More Services</p>
                    <div className='more-services-links'>
                        <a href="/radiology-laboratory"><p> Radiology & Laboratory</p></a>
                        <a href="/blood-bank"><p> Blood Bank</p></a>
                        <a href="/clinical-nutrition"><p> Clinical Nutrition</p></a>
                        <a href="/insurance-partners"><p> Insurance Partners</p></a>
                        <a href="/caritas-mortuary-services"><p> Caritas Mortuary Services</p></a>
                        <a href="/pastoral-care"><p> Pastoral Care</p></a>
                        <a href="https://www.caritashospital.org/health-checkup-packages"><p> Health Checkup Packages</p></a>
                        <a href="/video-consultation"><p> Video Consultation</p></a>
                    </div>
                </div>
            </section>

            {/* Page content ends here */}

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default HomeCare;